/**
 * App fonts.
 */
export const sansFont = "'Ubuntu', sans-serif";
export const monoFont = "'Ubuntu Mono', monospace";
